import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import '../../util/i18n'
import isMobileView from '../../util/MobileView'
import MarginWrapper from '../../features/wrappers/MarginWrapper'
import EditNameDesktop from './EditNameDesktop'
import EditNameMobile from './EditNameMobile'
import {
  fetchUser, selectUserObject, selectUserCallStatus, updateUser
} from '../../features/user/userSlice'
import {
  setFirstName, setLastName, setfullName, setErrors, resetErrors, setIsDisabled
} from './editNameSlice'

export function EditName() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const profile = useSelector(selectUserObject)
  const status = useSelector(selectUserCallStatus)

  const values = useSelector((state) => state.editName)
  const { errors } = values
  const { isDisabled } = values

  const nameRegex = {
    /*eslint-disable*/
    // only punctuation allowed: hyphens, apostrophe, space
    firstName:/[!\"#\$%&\(\)\*\+,\.\/:;<=>\?@\[\\\]^_`{\|}~]/,
    lastName: /[!\"#\$%&\(\)\*\+,\.\/:;<=>\?@\[\\\]^_`{\|}~]/,
  }

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchUser())
    }
  }, [status, dispatch])

  useEffect(() => {
    if (profile && values.firstName === '' && values.lastName === '') {
      dispatch(setfullName({
        firstName: profile.firstName || '',
        lastName: profile.lastName || '',
      }))
    }
  }, [profile])

  const handleChange = (e) => {
    const { name, value } = e.target
    if(name === 'firstName') dispatch(setFirstName(value));
    if(name === 'lastName') dispatch(setLastName(value));

    if(name === 'firstName' || name === 'lastName') {
      const isNotValidRegex = nameRegex[name].test(value) //if true, not valid
      const isTooLong = value.length > 30
      const isNotValid = isNotValidRegex || isTooLong
      dispatch(setErrors({
        [name]:isNotValid
      }))
      dispatch(setIsDisabled(isNotValid))
    } else {
      dispatch(setErrors({
        [name]:false
      }))
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const newErrs = {}
    const trimmedValues = {
      firstName: values.firstName.trim(),
      lastName: values.lastName.trim(),
    }
    if (!trimmedValues.firstName) newErrs.firstName = true
    if (nameRegex.firstName.test(trimmedValues.firstName)) newErrs.firstName = true 
    if (nameRegex.lastName.test(trimmedValues.lastName)) newErrs.lastName = true

    if (Object.keys(newErrs).length) {
      setErrors(newErrs)
      return
    }

    dispatch(updateUser(trimmedValues))
      .unwrap()
      .then(() => navigate('/account', {state: {editNameStatus: 'true'}}))
  }

  const handleCancel = () => {
    if(profile){
      dispatch(setfullName({
        firstName: profile.firstName || '',
        lastName: profile.lastName || '',
      }))
      dispatch(resetErrors({
        errors:{}
      }))
    }
    navigate('/account')
  }

  const getSupportText = (error, value, field)=>{
    if(!error) return ''
    
    if(value?.length > 30){
      return `${field}-length-is-long`
    }
    
    return 'error-invalid-character'
  }

  return (
    <MarginWrapper>
      {isMobileView() ? (
        <EditNameMobile
          t={t}
          userCallStatus={status}
          values={values}
          errors={errors}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          onCancel={handleCancel}
          isSaving={status === 'loading'}
          isDisabled={isDisabled}
          getSupportText={getSupportText}
        />
      ) : (
        <EditNameDesktop
          t={t}
          userCallStatus={status}
          values={values}
          errors={errors}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          onCancel={handleCancel}
          isSaving={status === 'loading'}
          isDisabled={isDisabled}
          getSupportText={getSupportText}
        />
      )}
    </MarginWrapper>
  )
}
